import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUnityComponent } from './simple-icons-unity.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUnityComponent ],
    exports:      [ SimpleIconsUnityComponent ],
    bootstrap:    []
})
export class SimpleIconsUnityModule {}
